var map = {
	"./AssessmentReport.svg": 242,
	"./Daily.svg": 243,
	"./EnrolledPatientReport.svg": 244,
	"./Failed.svg": 164,
	"./HF.svg": 245,
	"./Info-blue.svg": 167,
	"./Info-green.svg": 166,
	"./MOH.svg": 246,
	"./PatientDuplicateReport.svg": 247,
	"./PatientStatusReport.svg": 248,
	"./Pending.svg": 249,
	"./Permanent.svg": 250,
	"./Presc.svg": 251,
	"./ScreenedReport.svg": 252,
	"./Sierra Leone.svg": 253,
	"./Spice.svg": 254,
	"./SpiceEngage.svg": 255,
	"./UserPerformance.svg": 256,
	"./app-logo.svg": 154,
	"./arrow-right-small.svg": 257,
	"./assignQuickSightUser.svg": 168,
	"./avatar-o.svg": 258,
	"./bin.svg": 161,
	"./caret-down-grey.svg": 156,
	"./caret-down-white.svg": 259,
	"./checkbox-disabled.svg": 169,
	"./checkbox-empty.svg": 134,
	"./checkbox.svg": 135,
	"./close.svg": 170,
	"./download.svg": 100,
	"./dropdown.svg": 171,
	"./edit.svg": 99,
	"./hidePass.svg": 260,
	"./home.svg": 136,
	"./info-grey.svg": 261,
	"./info-orange.svg": 165,
	"./insights.svg": 262,
	"./no-icon.svg": 263,
	"./plus.svg": 157,
	"./power-switch.svg": 155,
	"./quickSightUser.svg": 172,
	"./reports.svg": 264,
	"./reset.svg": 265,
	"./search.svg": 158,
	"./send-disabled.svg": 266,
	"./send.svg": 267,
	"./showPass.svg": 162,
	"./success-blue.svg": 268,
	"./success-green.svg": 163,
	"./tick.svg": 269,
	"./user-role-assigned.svg": 173,
	"./user-role-not-assigned.svg": 174,
	"./warning.svg": 270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;